export function LoadingScreen() {
    return (
        <div className="loading-screen">
            <div className="spinner"></div>
        </div>
    );
}
